import { IgnoreChanges, IgnoreHistory } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IFileTextureLayer } from '../kb3d-models';
import { Token } from '../token';
import { TextureLayer } from './texture-layer';

@Kb3dModel<FileTextureLayer>({
    token: Token.FileTextureLayer,
    onSerializing: (node, o) => {
        return !node._external; // TODO Copy this to other layer types
    },
})
export class FileTextureLayer extends TextureLayer implements IFileTextureLayer {
    path = '';

    @IgnoreChanges _needsImageUpdate = false;
    @IgnoreHistory
    _buffer?: ImageBitmap; // the image data is saved here
    _bufferSource: string; // to trigger changes 

    width: number;
    height: number;

    flipNormalsRg = false;
}
